interface LiveBroadcastIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export function LiveBroadcastIcon({
  size = 20,
  color = "#EF4444",
  className = "",
}: LiveBroadcastIconProps) {
  return (
    <span
      className={`live-broadcast-icon inline-flex items-center justify-center shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid="icon-live-broadcast"
    >
      <svg
        viewBox="0 0 32 32"
        fill="none"
        width={size}
        height={size}
      >
        <g className="live-wave live-wave-outer" opacity="0.5">
          <path
            d="M5.5 6.5C2.5 9.8 1 13.7 1 16s1.5 6.2 4.5 9.5"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M26.5 6.5C29.5 9.8 31 13.7 31 16s-1.5 6.2-4.5 9.5"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
          />
        </g>
        <g className="live-wave live-wave-mid" opacity="0.7">
          <path
            d="M9 10C7 12 6 13.8 6 16s1 4 3 6"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M23 10C25 12 26 13.8 26 16s-1 4-3 6"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
          />
        </g>
        <g className="live-wave live-wave-inner" opacity="0.9">
          <path
            d="M12.5 12.5C11.2 13.8 10.5 14.8 10.5 16s.7 2.2 2 3.5"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M19.5 12.5C20.8 13.8 21.5 14.8 21.5 16s-.7 2.2-2 3.5"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
          />
        </g>
        <path
          d="M14 12.5V19.5L20 16L14 12.5Z"
          fill={color}
        />
      </svg>
    </span>
  );
}
